import login from "./login";
import forgot from "./forgot";

const AuthLayout = () => import(/* webpackChunkName: "auth" */ "@/layouts/_bit/auth");

const authLayout = [
  {
    path: "/",
    name: "AuthLayout",
    redirect: { name: "Login" },
    component: AuthLayout,
    children: [...login, ...forgot],
  },
];

export default authLayout;
